import type React from 'react';
import type { PropsWithChildren } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

export type TotalCardProps = {
    title: React.JSX.Element | string;
    startDate?: Date;
    endDate?: Date;
    type?: 'dashboard' | 'other';
    hasNewLabel?: boolean;
};

const TotalCard = ({
    title,
    startDate,
    endDate,
    children,
    type = 'other',
    hasNewLabel = false,
}: PropsWithChildren<TotalCardProps>) => {
    const { locale } = useIntl();
    const startDateString = startDate ? startDate.toLocaleDateString(locale) : 'N/A';
    const endDateString = endDate ? endDate.toLocaleDateString(locale) : 'N/A';
    return (
        <div className='display-flex height-100pct width-100pct flex-column align-items-center gap-5 padding-25'>
            <div className='display-flex align-items-center'>
                <span className={`${type === 'dashboard' ? 'text-size-16' : 'text-size-h4'}`}>{title}</span>
                {hasNewLabel && (
                    <span className='label label-danger label-filled margin-left-5 padding-2 text-normal'>
                        <FormattedMessage id='general.new' />
                    </span>
                )}
            </div>
            {children}
            {startDate || endDate ? (
                startDateString === endDateString ? (
                    <span className='text-color-dark padding-top-3'>{`${startDateString}`}</span>
                ) : (
                    <span className='text-color-dark padding-top-3'>{`${startDateString} - ${endDateString}`}</span>
                )
            ) : null}
        </div>
    );
};

export default TotalCard;
